import PropTypes from "prop-types";
import React from 'react'
import { Alert } from 'reactstrap'


const  AlertComponent = (props) => {
  const {error, success, errorMessage, successMessage } = props;

  if ( error ) {
    return (
      <Alert color="danger" isOpen={error}>
        {errorMessage}
      </Alert>
    )
  } else if ( success ) {
    return (
      <Alert color="info" isOpen={success}>
        {successMessage}
      </Alert>
    )
  } else {
    return null
  }
}

AlertComponent.propTypes = {
  error: PropTypes.bool,
  errorMessage: PropTypes.string,
  success: PropTypes.bool,
  successMessage: PropTypes.string
}

export default AlertComponent
